import { render, staticRenderFns } from "./create-setting.vue?vue&type=template&id=0cb3f87c&scoped=true&"
import script from "./create-setting.vue?vue&type=script&lang=js&"
export * from "./create-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb3f87c",
  null
  
)

export default component.exports